/**
 * Clinic contact details shown in the footer and on the Locations page.
 * Source of truth: the "Contact us" slide of the PawGlobal Company Profile deck.
 */

/**
 * @typedef {Object} ContactChannel
 * @property {string} id    Stable key.
 * @property {string} label Channel name shown above the value, e.g. "WhatsApp".
 * @property {string} value Link text, exactly as it should appear.
 * @property {string} href  Where the link goes.
 */

const WHATSAPP_NUMBER = '+855 96 354 9862';
const TELEGRAM_HANDLE = 'pawglobal';
const EMAIL = 'pawvet60@gmail.com';

const digitsOnly = (phoneNumber) => phoneNumber.replace(/\D/g, '');

/** @type {ContactChannel[]} */
export const CONTACT_CHANNELS = [
  {
    id: 'whatsapp',
    label: 'WhatsApp',
    value: WHATSAPP_NUMBER,
    href: `https://wa.me/${digitsOnly(WHATSAPP_NUMBER)}`,
  },
  {
    id: 'telegram',
    label: 'Telegram',
    value: `@${TELEGRAM_HANDLE}`,
    href: `https://t.me/${TELEGRAM_HANDLE}`,
  },
  {
    id: 'email',
    label: 'Email',
    value: EMAIL,
    href: `mailto:${EMAIL}`,
  },
];

export const CONTACT_ADDRESS_LINES = [
  'No 60 Street 608, Village 8, Sangkat Beoung Kak 2,',
  'Khan Toul Kork, Phnom Penh',
];

const MAPS_SEARCH_URL = 'https://www.google.com/maps/search/?api=1&query=';

export const CONTACT_ADDRESS = CONTACT_ADDRESS_LINES.join(' ');
export const DIRECTIONS_URL = `${MAPS_SEARCH_URL}${encodeURIComponent(CONTACT_ADDRESS)}`;
